import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { CardWarning } from '../../../../../components/CardWarning';

interface SortableWarningCardProps {
  id: string;
  title: string;
  content: string;
  dateLabel: string;
  functionRemoveButton: () => void;
  functionChangeButton: () => void;
}

const SortableWarningCard: React.FC<SortableWarningCardProps> = ({
  id,
  ...rest
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <CardWarning
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
      }}
      dragHandleProps={{ ...attributes, ...listeners }}
      {...rest}
    />
  );
};

export { SortableWarningCard };
